export var TextStyles = function (props, theme) {
    var as = props.as, className = props.className, block = props.block, nowrap = props.nowrap, variant = props.variant;
    var fonts = theme.fonts;
    var variantObject = variant && fonts[variant] ? fonts[variant] : undefined;
    return {
        root: [
            theme.fonts.medium,
            {
                display: block ? (as === 'td' ? 'table-cell' : 'block') : 'inline',
                fontFamily: (variantObject && variantObject.fontFamily) || 'inherit',
                fontSize: (variantObject && variantObject.fontSize) || 'inherit',
                fontWeight: (variantObject && variantObject.fontWeight) || 'inherit',
                color: (variantObject && variantObject.color) || 'inherit',
                mozOsxFontSmoothing: variantObject && variantObject.MozOsxFontSmoothing,
                webkitFontSmoothing: variantObject && variantObject.WebkitFontSmoothing
            },
            nowrap && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            className
        ]
    };
};
//# sourceMappingURL=Text.styles.js.map